import { customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { uuidv4 } from 'framework/script_utilities/uuid-generator';
import { CountryExperience } from 'model/forms/travel-request';

@customElement('country-experiences-panel')
export class CountryExperiencesCustomElement {
  @bindable items: CountryExperience[];
  @bindable radioName = `__radio-${uuidv4()}`;
  @bindable disabled: boolean;

  getItemIcon(item: CountryExperience) {
    return item.country.formFlag ?? 'fas fa-globe-africa';
  }
}
